import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { useRef } from "react"
import useSticky from "hooks/useSticky"
import Social from "./social"
import OffCanvas from "./offCanvas"

const Navbar = props => {
  const { navClassName, info, social, fancy, navOtherClass, stickyBox } = props

  const sticky = useSticky(350)
  const navbarRef = useRef(null)

  // dynamically render the logo
  //const logo = sticky ? "logo-dark" : logoAlt ?? "logo-dark"
  // dynamically added navbar classname
  const fixedClassName =
    "navbar navbar-expand-lg center-nav transparent navbar-light navbar-clone fixed"

  // render inner nav item links
  /*const renderLinks = links => {
    return links.map(item => (
      <ListItemLink
        href={item.url}
        title={item.title}
        linkClassName="dropdown-item"
        key={item.id}
      />
    ))
  }*/

  // all main header contents
  const headerContent = (
    <>
      <div className="navbar-brand w-100">
        <Link to="/">
          <StaticImage
            src="../../assets/img/logo-com2com.jpg"
            style={{ width: "80px", height: "80px" }}
          />
        </Link>
      </div>

      <OffCanvas />

      <div className={navOtherClass}>
        <ul className="navbar-nav flex-row align-items-center ms-auto">
          {info && (
            <li className="nav-item">
              <a
                href="/"
                className="nav-link"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvas-info"
              >
                <i className="uil uil-info-circle" />
              </a>
            </li>
          )}

          {social && <Social />}

          {/* ============= humburger button for small device ============= */}
          <li className="nav-item d-lg-none">
            <button
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvas-nav"
              className="hamburger offcanvas-nav-btn"
            >
              <span />
            </button>
          </li>
        </ul>
      </div>
    </>
  )

  return (
    <>
      {stickyBox && (
        <div
          style={{ paddingTop: sticky ? navbarRef.current?.clientHeight : 0 }}
        />
      )}

      <nav ref={navbarRef} className={sticky ? fixedClassName : navClassName}>
        {fancy ? (
          <div className="container">
            <div className="navbar-collapse-wrapper bg-white d-flex flex-row flex-nowrap w-100 justify-content-between align-items-center">
              {headerContent}
            </div>
          </div>
        ) : (
          <div className="container flex-lg-row flex-nowrap align-items-center">
            {headerContent}
          </div>
        )}
      </nav>
    </>
  )
}

// set deafult Props
Navbar.defaultProps = {
  cart: false,
  info: false,
  social: false,
  search: false,
  language: false,
  stickyBox: true,
  navOtherClass: "navbar-other w-100 d-flex ms-auto",
  navClassName: "navbar navbar-expand-lg center-nav transparent navbar-light",
}

export default Navbar
